import sendEmail from './'

import { homeUrl } from 'config'

const sendDownloadEmail = (
  userEmail: string,
  link: string,
  userName: string
) => {
  const subject = 'Download application link'

  const body = `
  <html>

  <body>
    <div style="
        text-align: center;
      ">
      <div style="
      border: 1px solid rgb(235, 235, 237);
      border-radius: 2px;
      text-align: center;
      max-width: 43.75rem;
      margin: 0 auto;
    ">
        <div style="margin: 3rem auto 0;">
          <a href="${homeUrl}">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/giantleap-82ce7.appspot.com/o/images%2FEmailLogo.png?alt=media&token=cc9bb3bd-11d1-4a2a-adb7-80f41c2da2cc"
              alt="" style="
        width: 7rem;
      " />
          </a>
        </div>
        <h3 style="
        font-size: 24px;
        color: #1a242e;
        font-family: montserrat,Helvetica,sans-serif;
        margin: 2.5rem auto 0;
      ">
          Hi ${userName || ''}
        </h3>
        <p style="
        font-family: tahoma,sans-serif;
        color: rgb(65,62,77);
        font-size: 16px;
        margin: 1rem auto 2rem;
      ">
          Please click on the button below to open store and download our app:
        </p>
        <a href="${link}" style="
          background: #ff20e9;
          color: #ffffff;
          font-family: tahoma,sans-serif;
          font-size: 18px;
          font-weight: normal;
          margin: 2rem auto 0;
          text-decoration: none;
          text-transform: uppercase;
          border-radius: 2px;
          padding: 0.5rem 2rem;
        ">Download</a>
        <p style="
          color: #413e4d;
          margin: 3.5rem auto 0;
        ">Have a great day,<br />
          GiantLeap Team</p>
        <p style="
        color: #aaaaaa;
        font-family: tahoma,sans-serif;
        margin: 1.5rem auto 0;
      ">Need help? Contact <a style="color: #4190ff;" href="mailto:${
        process.env.REACT_APP_SUPPORT_EMAIL
      }">support@giantleap.tech</p>
        <p style="
        font-family: helvetica,sans-serif;
        line-height: 1.5;
        font-size: 12px;
        color: #030303;
        margin: 3.5rem auto 3.5rem;
      ">
          181 Metro Dr Ste 410<br />
          San Jose, CA 95110-134
        </p>
      </div>
    </div>
  </body>
  
  </html>
  
  `
  const text = `
  Download App Link
  ${link}
  If this email address has been provided without your consent or if you wish to delete the account request for any reason, please send an email to privacy@giantleap.tech
  Policy (https://www.giantleap.tech/privacy) and Terms of Use (https://www.giantleap.tech/terms).
  `

  return sendEmail(userEmail, subject, body, text)
}

export default sendDownloadEmail



// WEBPACK FOOTER //
// ./src/services/email/downloadAppEmail.ts